




























import { Component, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { Actions, Mutations, GlobalOverlays } from '@/ts/store/Constants';

@Component({
    computed: {
        ...mapGetters({
            userTicketCurrentCategory: 'UserTickets/getUserTicketCurrentCategory',
            userTicketAllInquiries: 'UserTickets/getUserTicketAllInquiries',
        }),
    },
})
export default class AddNewTicketInquiry extends Vue {
    constructor() {
        super();
    }

    public back() {
        this.$store.commit(Mutations.SET_USER_TICKET_ALL_INQUIRIES, []);
        this.$store.commit(Mutations.SET_USER_CURRENT_TICKET_CATEGORY, []);
        this.$store.commit(Mutations.SET_GLOBAL_OVERLAY_COMPONENT, GlobalOverlays.TICKET_CATEGORY);
    }

    public setNewTicketInquiry(inquiryId: number) {
        this.$store.dispatch(Actions.FETCH_USER_CURRENT_TICKET_INQUIRY, inquiryId);
    }

    public close() {
        this.$store.commit(Mutations.SET_ADD_NEW_TICKET_INQUIRY_VISIBILITY, false);
    }
}
